/**
 * Builds a storefront URL that targets a specific variant.
 * Shopify: https://shop/products/handle?variant={id}
 */
export function buildRemoteVariantUrl(
  productUrl: string | null | undefined,
  variantId: string
): string {
  if (!productUrl?.trim()) return "";

  try {
    const url = new URL(productUrl.trim());
    url.searchParams.set("variant", variantId);
    return url.toString();
  } catch {
    const base = productUrl.trim();
    const separator = base.includes("?") ? "&" : "?";
    return `${base}${separator}variant=${encodeURIComponent(variantId)}`;
  }
}
